module.exports = __webpack_public_path__ + "img/robot.8cf75e16.png";